import React, { useState } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Accordion,
    AccordionSummary,
    AccordionDetails,
    Typography,
    Box,
    List,
    ListItem,
    ListItemText,
    Alert,
} from '@mui/material';
import Iconify from 'src/components/iconify';
import { HOST_ROOT } from 'src/config-global';
import Scrollbar from 'src/components/scrollbar';
import { useTranslation } from 'react-i18next';

interface PaymentModalProps {
    open: boolean;
    onClose: () => void;
}

const MakePayment: React.FC<PaymentModalProps> = ({ open, onClose }) => {
    const { t } = useTranslation();
    // State to manage expanded accordions
    const [expanded, setExpanded] = useState<string | false>(false);

    // Handle accordion expansion
    const handleAccordionChange = (panel: string) => (event: React.SyntheticEvent, isExpanded: boolean) => {
        setExpanded(isExpanded ? panel : false);
    };

    // Handle PayPal payment
    // const handlePayPalPayment = () => {
    //     enqueueSnackbar('Redirecting to PayPal...', { variant: 'info' });
    //     // Add PayPal payment logic here
    // };

    // Handle credit card payment
    const handleCreditCardPayment = () => {
        window.open(`${HOST_ROOT}/pricing`, '_blank');
    };

    // Bank transfer details
    const bankTransferDetails = [
        { label: t('common.input.rib.label2'), value: 'ATTIJARIWAFA BANK' },
        { label: t('pricing.dialog.account'), value: 'LBANKA COM' },
        { label: t('common.input.rib.label'), value: '007561000941730031002622' },
        { label: t('pricing.dialog.swift'), value: 'BCMAMAMCXXX' },
    ];

    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle>{t('pricing.dialog.title')}</DialogTitle>
            <DialogContent>
                {/* Wrap the content with Scrollbar */}
                <Scrollbar sx={{ maxHeight: '400px' }}>
                    {/* PayPal Accordion */}
                    <Accordion
                        expanded={expanded === 'paypal'}
                        onChange={handleAccordionChange('paypal')}
                    >
                        <AccordionSummary expandIcon={<Iconify icon="eva:chevron-down-fill" />}>
                            <Button
                                fullWidth
                                variant="contained"
                                color="primary"
                                sx={{ backgroundColor: "orange" }}
                                startIcon={<Iconify icon="logos:paypal" />}
                            >
                                {t('pricing.dialog.pay-with-paypal')}
                            </Button>
                        </AccordionSummary>
                        <AccordionDetails>
                            <List>
                                <ListItem>
                                    <ListItemText primary={t('common.input.email.label')} secondary='Paypal@Lbanka.com' />
                                </ListItem>
                            </List>
                        </AccordionDetails>
                    </Accordion>

                    {/* Bank Transfer Accordion */}
                    <Accordion
                        expanded={expanded === 'bankTransfer'}
                        onChange={handleAccordionChange('bankTransfer')}
                    >
                        <AccordionSummary expandIcon={<Iconify icon="eva:chevron-down-fill" />}>
                            <Typography variant="subtitle1">{t('pricing.dialog.pay-with-transfer')}</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <List>
                                {bankTransferDetails.map((detail, index) => (
                                    <ListItem key={index}>
                                        <ListItemText primary={detail.label} secondary={detail.value} />
                                    </ListItem>
                                ))}
                            </List>
                            <Alert>{t('pricing.dialog.pay-with-transfer-alert')}</Alert>
                        </AccordionDetails>
                    </Accordion>

                    {/* Credit Card Option */}
                    <Box mt={2}>
                        <Button
                            fullWidth
                            variant="contained"
                            color="secondary"
                            onClick={handleCreditCardPayment}
                            startIcon={<Iconify icon="ic:baseline-credit-card" />}
                            disabled
                        >
                            {t('pricing.dialog.pay-with-card')}
                        </Button>
                    </Box>
                </Scrollbar>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} variant="outlined" color="inherit">
                    {t('common.button.action.close')}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default MakePayment;